<template>
  <v-container fill-height fluid>
    <v-row align="center"
           justify="center">
      <v-col>

        <v-card
            elevation="24"
            shaped
            class="card"
        >
          <v-card-title class="logos">
            <div class="title-img left"></div>
            <div class="title-img right"></div>
          </v-card-title>
          <v-card-title style="padding-top: 0;word-wrap: normal !important;">Rally & Communication Andrzej Buziewicz</v-card-title>
          <v-card-subtitle style="text-align: justify;padding-bottom: 6px">
            <p>Rally & Communication to premium partner Webfleet Solutions – a Bridgestone company. Rally & Communication zajmuje się dostarczaniem czołowych rozwiązań telemetrycznych do zarzadzania flotą od małych firm do ogromnych koncernów transportowych oraz rozwiązań pod ochronę 24/7 samochodów klasy premium.</p>
            <br>
            <p>W Webfleet Solutions pomagamy naszym klientom zbliżyć się do swoich kierowców. Wszystko, co robimy, wynika z jednej prostej zasady — jeśli jesteś blisko spraw swoich kierowców, każdy może podejmować mądrzejsze decyzje.</p>
            <!--        <p>To przekonanie w połączeniu z naszą ciągłą innowacyjnością, dążeniem do stawiania klienta na pierwszym miejscu oraz nieusta­jącym podno­szeniem jakości i nieza­wod­ności sprawiło, że jesteśmy liderami branży w Europie i jednym z czołowych graczy na świecie w dziedzinie telematyki pojazdów i zarządzania flotą pojazdów.</p>-->
          </v-card-subtitle>
          <v-card-text class="footer">
            <v-container fluid style="padding: 0">
              <v-row justify="end" no-gutters>
                <v-col cols="12" sm="6" align="left" class="buttons">
                  <div style="margin-top: auto">
                    <v-btn
                        class="button"
                        small
                        href="https://www.webfleet.com/pl_pl/webfleet/products/login/?application=webfleet"
                        target="_blank"
                    >Logowanie do WEBFLEET
                    </v-btn>
                    <v-btn
                        class="button facebook"
                        small
                        icon
                        href="https://www.facebook.com/WebfleetSolutionsRallyCommunication"
                        target="_blank"
                    >
                    <v-icon large>
                      mdi-facebook
                    </v-icon>
                  </v-btn>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" align="right">
                  <dt>E-mail:</dt>
                  <dd>{{ getEmail }}</dd>
                  <dt>Biuro:</dt>
                  <dd>{{ getOffice }}</dd>
                  <dt>Tel.:</dt>
                  <dd>{{ getMobile }}</dd>
                  <div class="spacer" style="clear: both;"></div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "RCCard",
  data() {
    return {
      email: ['a', 'n', 'd', 'r', 'z', 'e', 'j', '.', 'b', 'u', 'z', 'i', 'e', 'w', 'i', 'c', 'z', '@', 'g', 'm', 'a', 'i', 'l', '.', 'c', 'o', 'm'],
      office: ['+', '4', '8', ' ', '2', '2', ' ', '2', '0', '3', ' ', '7', '1', ' ', '0', '6'],
      mobile: ['+', '4', '8', ' ', '5', '0', '2', ' ', '4', '7', '7', ' ', '8', '1', '7']
    }
  },
  computed: {
    getEmail: function () {
      return this.email.join('')
    },
    getOffice: function () {
      return this.office.join('')
    },
    getMobile: function () {
      return this.mobile.join('')
    }
  }
}
</script>

<style scoped lang="scss">
.card {
  margin-left: auto;
  margin-right: auto;
  width: 46rem;
  min-height: 24rem;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, .2) !important;
  box-shadow: 0 6px 2px -4px rgba(0, 0, 0, .4), 0 4px 4px 0 rgba(0, 0, 0, .28), 0 2px 10px 0 rgba(0, 0, 0, .24) !important;
}

.title-img {
  max-height: 3.5rem;
  width: auto;
  position: relative;
  height: 3.5rem;
  min-width: 50%;
  margin: 0 auto;
  background-size: contain;
  background-repeat: no-repeat;

  &.left {
    background-image: url("/RC.jpg");
    background-position: center left;
  }

  &.right {
    background-image: url("/WF_Premium_Partner_logo_RGB.jpg");
    background-position: center right;
  }
}

div.dl {
  width: 100%;
  padding: 0;
  margin: 0
}

dt {
  float: left;
  width: 40%;
  padding: 0;
  margin: 0
}

dd {
  float: left;
  width: 60%;
  padding: 0;
  margin: 0;
  color: black !important;
}

.buttons {
  display: flex;
  flex-direction: column;
  margin-left: 0;
  margin-bottom: 0;
  .button {
    //margin-top: auto;
    text-transform: none;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
    margin: 8px
  }

  .facebook {
    color: #4267B2 !important;
  }
}
</style>
